import { useContext, useState, useRef, useEffect } from "react";
import { Handle, Position, useUpdateNodeInternals } from "@xyflow/react";
import { StoreContext } from "../../store/Store";
import { GlobalRefContext } from "../../store/GlobalRefs";
import { actionTypes } from "../../store/storeTypes";
import { handleStyles, handleStyle } from "./customNodeStyles";

export const StartNode = ({ data }) => {
  const [store, dispatch] = useContext(StoreContext);
  const grefs = useContext(GlobalRefContext);
  const { showHandles, mode, nodes } = store;
  const [selectedHandle, setSelectedHandle] = useState(null);
  const [positions, setPositions] = useState(null);
  const nodeRef = useRef(null);
  const updateNodeInternals = useUpdateNodeInternals();

  useEffect(() => {
    if (data.handles) {
      setPositions({
        target: data.handles.target,
        source: data.handles.source,
      });
    }
  }, [data.handles]);

  const onHandleSelect = (type) => {
    setSelectedHandle(type);
  };
  const onNodeClick = (ev) => {
    if (selectedHandle) {
      const box = nodeRef.current.getBoundingClientRect();
      const middleX = box.left + box.width / 2;
      const middleY = box.top + box.height / 2;
      const candidates = [
        ev.clientX < middleX ? "Left" : "Right",
        ev.clientY < middleY ? "Top" : "Bottom",
      ].filter((item) => {
        return positions["target"] !== item && positions["source"] !== item;
      });

      const newPositions = { ...positions, [selectedHandle]: candidates[0] };
      setPositions(newPositions);
      updateNodeInternals(data.id);

      //update handles
      const copyHandles = { ...grefs.handleRef.current };
      copyHandles[data.id] = {
        source: newPositions.source,
        target: newPositions.target,
      };
      grefs.handleRef.current = copyHandles;
    } else {
      if (mode === "flow") {
        grefs.selectedRef.current[data.id] = {};
      }
      //get next node
      const targets = grefs.edgeCollectionRef.current.filter((edge) => {
        return edge.source === data.id;
      });
      const target = targets[0].target;
      //add new active node
      const newActiveNode = grefs.nodeCollectionRef.current.find(
        (node) => node.id === target
      );
      if (!nodes.map((node) => node.id).includes(target)) {
        const newActiveNodes = nodes.concat([newActiveNode]);

        grefs.ignoreNodeChange.current = true;
        grefs.focusRef.current = target;
        dispatch({
          type: actionTypes.SET_NODES,
          payload: newActiveNodes,
        });
      } else {
        dispatch({ type: actionTypes.SET_FOCUSID, payload: target });
      }
    }
  };

  return positions ? (
    <>
      {showHandles && (
        <>
          <div
            style={{
              ...handleStyles()[positions.source],
              backgroundColor: selectedHandle === "source" ? "red" : "orange",
            }}
            onClick={() => onHandleSelect("source")}
          ></div>
        </>
      )}
      <div
        ref={nodeRef}
        style={{ ...data.style, width: undefined }}
        onClick={(ev) => onNodeClick(ev)}
      >
        {data.label}
      </div>
      <Handle
        style={handleStyle(data, grefs, "source")}
        type="source"
        position={Position[positions.source]}
      />
    </>
  ) : null;
};
